export const ANALYTIC_EVENTS = {
  ivStarted: '[IV] Starting the IV process',
  ivTakingPhoto: '[IV] Taking IV photo',
  ivUploadingPhoto: '[IV] Uploading IV photo',
  ivPhotoSent: '[IV] Photo is sent',
  ivPhotoTaken: '[IV] Photo is taken',
  ivResetPhoto: '[IV] Reset photo',
  ivPhotoUploaded: '[IV] Photo is uploaded',
  ivTakingPhotoError: '[IV] Error of taking photo',
  ivUploadingPhotoError: '[IV] Error of uploading photo',
  ivRetryingLimitOver: '[IV] Retrying limit is over',
  ivGettingResultsFromOCR: '[IV] Getting results from OCR',
  ivParsingOfDetectedOCRData: '[IV] Parsing of detected OCR data',
  ivGettingResultsFromBiomatch: '[IV] Getting results from Biomatch',
  ivGettingResultsFromBiomatchMatching: '[IV] Getting results from Biomatch matching',
  ivFinishingAllSuccessfully: '[IV] Finishing the whole process successfully',
  ivFinishingFrontSideDocument: '[IV] Document front side verified',
  ivFinishingBackSideDocument: '[IV] Document back side verified',
  ivFinishingDocumentMRZScan: '[IV] Document verified (MRZScan)',
  ivFinishingDocumentFace: '[IV] Document face verified',
  ivFinishingSelfie: '[IV] Selfie verified',
  ivFinishingMatching: '[IV] Document and selfie matched',

  ivError: '[IV] Error or Failed',
  ivLeaving: '[IV] Leaving views',
  ivSkipping: '[IV] Skipping the process',
};
